import {
  assertSeedance25SubmissionProvider,
  buildSeedance25ReferencePayload,
  getSeedance25Capabilities,
  getSeedance25ReferenceMediaType,
  getSeedance25ReferenceUrl,
  normalizeSeedance25Duration,
  normalizeSeedance25RatioForMode,
  normalizeSeedance25ReferencePrompt,
  normalizeSeedance25Resolution,
  normalizeSeedance25SubmissionProvider,
  validateSeedance25References,
} from '../../../utils/seedance25Capabilities';
import { getNodeImageUrl } from '../canvasUtils';
import { getNodeOutputType } from './connectionRules';

// Only 2.5 uses this path. Source URLs identify current-library registrations;
// the server replaces them with verified IDs, never a stale node's asset ID.
export const buildCanvasSeedance25Submission = ({ provider, formData, referenceNodes = [], defaultRatio = '9:16' }) => {
  assertSeedance25SubmissionProvider(provider);
  const submissionProvider = normalizeSeedance25SubmissionProvider(provider);
  const capabilities = getSeedance25Capabilities(submissionProvider);
  if (!capabilities) throw new Error('缺少明确的即梦 2.5 视频线路');
  const references = referenceNodes.filter(node => getNodeOutputType(node) !== 'text').map(node => {
    const data = node.data || {};
    const outputType = getNodeOutputType(node);
    const mediaType = ['video', 'audio'].includes(outputType) ? outputType : getSeedance25ReferenceMediaType(data);
    return { ...data, mediaType, url: getSeedance25ReferenceUrl(data) || getNodeImageUrl(data), name: data.name || data.prompt || '参考素材' };
  }).concat((formData.guaRefVideos || []).map(item => typeof item === 'string'
    ? { url: item, mediaType: 'video' } : { ...item, mediaType: 'video' }));
  const requestedMode = formData.seedance25Mode || formData.generationMode || formData.videoGenerationMode
    || ({ i2v: 'img2video', t2v: 'text2video', ref2v: 'reference' }[formData.guaVideoMode])
    || (references.length ? 'reference' : 'text2video');
  const mode = requestedMode === 'reference' && !references.length ? 'text2video' : requestedMode;
  if (!capabilities.modes.includes(mode)) throw new Error(`${capabilities.label} 不支持当前生成模式`);
  const result = {
    provider: submissionProvider, model: capabilities.model, generationMode: mode,
    duration: String(normalizeSeedance25Duration(submissionProvider, formData.videoDuration, 5)),
    resolution: normalizeSeedance25Resolution(submissionProvider, formData.videoResolution),
    ratio: normalizeSeedance25RatioForMode(submissionProvider, mode, formData.aspectRatio || formData.guaRatio, defaultRatio),
    prompt: formData.prompt,
  };
  result.aspectRatio = result.ratio;
  if (capabilities.supportsGenerateAudioControl) result.generateAudio = formData.generateAudio ?? formData.guaAudio ?? formData.videoAudio ?? true;
  if (capabilities.supportsWatermarkControl) result.watermark = formData.watermark === true;
  if (mode === 'text2video') return result;
  if (mode === 'reference') {
    Object.assign(result, buildSeedance25ReferencePayload(submissionProvider, references));
    result.prompt = normalizeSeedance25ReferencePrompt(submissionProvider, result.prompt, references);
    return result;
  }
  const frames = mode === 'start-end' ? references.slice(0, 2) : references.slice(0, 1);
  if (frames.length !== (mode === 'start-end' ? 2 : 1)
    || frames.some(item => getSeedance25ReferenceMediaType(item) !== 'image')
    || validateSeedance25References(submissionProvider, frames).rejected.length) {
    throw new Error('首帧或尾帧缺少原始图片 URL，请重新选择原图；素材库 ID 不能替代图片');
  }
  result.startImageUrl = getSeedance25ReferenceUrl(frames[0]);
  if (mode === 'start-end') result.endImageUrl = getSeedance25ReferenceUrl(frames[1]);
  return result;
};
